<template>
  <div>
    <h2>Fiddler Header 转 dict</h2>
    <a-row>
      <a-col :span="11">
        <a-textarea placeholder="请将Fiddler Header值粘贴进来" style="height:500px;" v-model="rawData" />
      </a-col>

      <a-col :span="2" style="text-align:center">
        <a-button v-on:click="transClick">转换</a-button>
      </a-col>

      <a-col :span="11">
        <ToolRightWrapper :transData="transData" />

        <!-- <a-textarea placeholder="转换后的结果" style="height:500px;" v-model="transData" /> -->
      </a-col>
    </a-row>
    <div class="content">
      <h2>使用方法</h2>
      <a-row>
        <ol class="use-direction">
          <a-col :span="8">
            <li>选取抓包工具 Raw 内容里的<b>请求头</b>部分复制，支持 Fiddler 或 Charles</li>

            <div>
              <p style="margin:0.1rem;font-size:15px">
                <b>Fiddler:</b>
              </p>
              <img src="https://images.alisen39.com/20200525223530.png" alt />

            </div>

            <div>
              <p style="margin:0.1rem;font-size:15px">
                <b>Charles:</b>
              </p>
              <img src="https://images.alisen39.com/20200525224726.png" alt />

            </div>


          </a-col>

          <a-col :span="15" :offset="1">
            <li>将其粘贴至本页面左边窗口 ，点击"转换"按钮即可得到结果</li>
            <img src="https://images.alisen39.com/20200525224240.png" alt />
          </a-col>
        </ol>
      </a-row>
    </div>


    
  </div>
</template>

<script>
const axios = require('axios')
import ToolRightWrapper from '../components/ToolRightWrapper.vue'

export default {
  name: 'FiddlerHeader',
  components: {
    ToolRightWrapper
  },
  metaInfo: {
    title: 'Fiddler Header转Dict格式 | 麦麦麦造的小站', // set a title
    meta: [
      {
        // set meta
        name: 'keyWords',
        content:
          'Fiddler,Fiddler data,Fiddler Cookie,数据采集工具,爬虫开发工具,Http raw,快速爬虫开发'
      },
      {
        name: 'description',
        content: '将Fiddler里的Header项快速的转换为Python里的Dict格式'
      }
    ]
  },
  data() {
    return {
      rawData: '',
      transData: ''
    }
  },
  methods: {
    transClick() {
      const _this = this
      if (this.$data.rawData.replace(' ', '').length <= 0) {
        this.$message.error('还没有输入参数哦！')
        return
      }

      axios({
        url: '/tools/fiddler_header/',
        method: 'post',
        data: {
          data: this.$data.rawData
        }
      })
        .then(function(response) {
          if (response.data['code'] != 200) {
            _this.$message.warning(response.data['msg'])
            return
          }
          _this.$data.transData = response.data['data'].replace(/',\s/g,"',\n")
        })
        .catch(function(error) {
          _this.$message.error(error.message)
          // console.log(error)
        })
    }
  }
}
</script>
<style>
@import url('./tools.css');

/* textarea {
  resize: none;
}
.content {
  margin-top: 1rem;
}
.use-direction li {
  font-size: 15px;
  margin-bottom: 0.5rem;
}
.use-direction img {
  max-width: 100%;
  margin: 0 auto 3% auto;
} */
</style>